import { createSlice } from '@reduxjs/toolkit'

const actionPlanSlice = createSlice({
  name: 'actionPlan',
  initialState: {
    goal: {
      value: '',
    },
    goalKey: {
      value: null,
    },
    timeline: {
      value: '',
    },
    desiredTimeline: {
      value: null,
    },
    progressPercent: {
      value: 0,
    },
    trackerSectionInfo: {
      value: [],
    },
  },
  reducers: {
    setGoal: (state, action) => {
      state.goal.value = action.payload
    },
    setGoalKey: (state, action) => {
      state.goalKey.value = action.payload
    },
    setTimeline: (state, action) => {
      state.timeline.value = action.payload
    },
    setDesiredTimeline: (state, action) => {
      state.desiredTimeline.value = action.payload
    },
    setProgressPercent: (state, action) => {
      state.progressPercent.value = action.payload
    },
    setTrackerSectionInfo: (state, action) => {
      state.trackerSectionInfo.value = action.payload
    },
  },
  selectors: {
    selectGoal: (state) => state.goal.value,
    selectGoalKey: (state) => state.goalKey.value,
    selectTimeline: (state) => state.timeline.value,
    selectDesiredTimeline: (state) => state.desiredTimeline.value,
    selectProgressPercent: (state) => state.progressPercent.value,
    selectTrackerSectionInfo: (state) => state.trackerSectionInfo.value,
  },
})

export default actionPlanSlice.reducer
export const {
  setGoal,
  setGoalKey,
  setTimeline,
  setDesiredTimeline,
  setProgressPercent,
  setTrackerSectionInfo,
} = actionPlanSlice.actions
export const {
  selectGoal,
  selectGoalKey,
  selectTimeline,
  selectDesiredTimeline,
  selectProgressPercent,
  selectTrackerSectionInfo,
} = actionPlanSlice.selectors
